import PropTypes from 'prop-types';
import Icon from './Icon';

const CalenderCheck = ({ color, ...rest }) => (
  <Icon color={color} {...rest}>
    <path
      d="M9.16667 15.8444L13.9225 11.0885L12.7442 9.91021L9.16667 13.4877L7.25583 11.5769L6.0775 12.7552L9.16667 15.8444Z"
      fill={color}
    />
    <path
      d="M15.8333 3.83268H14.1667V2.16602H12.5V3.83268H7.5V2.16602H5.83333V3.83268H4.16667C3.2475 3.83268 2.5 4.58018 2.5 5.49935V17.166C2.5 18.0852 3.2475 18.8327 4.16667 18.8327H15.8333C16.7525 18.8327 17.5 18.0852 17.5 17.166V5.49935C17.5 4.58018 16.7525 3.83268 15.8333 3.83268ZM15.835 17.166H4.16667V8.83268H15.8333L15.835 17.166ZM15.8336 7.16602L15.8333 5.49935H4.16667V7.16602H15.8336Z"
      fill={color}
    />
  </Icon>
);

export default CalenderCheck;

CalenderCheck.propTypes = {
  color: PropTypes.string.isRequired
};
